import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MeilleursBiensService } from 'app/services/meilleuresBiens/meilleurs-biens.service';
import { SearchService } from 'app/services/search/search.service';
@Component({
  selector: 'app-meilleurs-bien-mahdia',
  templateUrl: './meilleurs-bien-mahdia.component.html',
  styleUrls: ['./meilleurs-bien-mahdia.component.scss']
})
export class MeilleursBienMahdiaComponent implements OnInit {

  public MeilleursBiens: any
  public search: string = ''
closeResult = '';
search_name1:any;
  p: Number = 1;
  dataSource = new MatTableDataSource();

  constructor(private meilleursBiensService: MeilleursBiensService,
    private searchService: SearchService) { }
 ngOnInit(): void {
  this.getMeilleursBiensMahdia();
     
  }
  getMeilleursBiensMahdia() {
    this.meilleursBiensService.getMeilleursBiensMahdia().subscribe((data: any) => {
    
      this.MeilleursBiens = data;
     
        console.log('meilleurs biens mahdia',this.MeilleursBiens)
        this.performSearch();
         

    })
  }

  


  SupprimerMeilleursBiens(MeilleursBiens: any) {
    this.meilleursBiensService.deleteMeilleursBiens(MeilleursBiens.id).subscribe((response: any) => {


      console.log(this.dataSource.data);


    });
 

  }
// Méthode pour effectuer la recherche
performSearch() {
  this.MeilleursBiens = this.searchService.search(this.MeilleursBiens, this.search);
}}

